module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    ref: "addForm",
    staticClass: "mt20",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.otaName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.appBind.label_version'),
      "prop": "version"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.xgscwj'),
      "prop": "filePath"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.qsczipwjls50')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_udfiletype'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.updateType),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateType", $$v)
      },
      expression: "form.updateType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ttPkg')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.updateType),
      callback: function($$v) {
        _vm.$set(_vm.form, "updateType", $$v)
      },
      expression: "form.updateType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dfPkg')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.azbdz')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.filePath),
      callback: function($$v) {
        _vm.$set(_vm.form, "filePath", $$v)
      },
      expression: "form.filePath"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds'),
      "prop": "mechanismId"
    }
  }, [(_vm.mechanismData.value) ? _c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a91e83ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/romEdit.vue
// module id = 1112
// module chunks = 0